import React, { ReactNode } from 'react';
import { User } from '../../../interfaces/backend/User';
import { CodeType } from '../CodeType';
import { BuildCodeParams } from './CodeSample';
import Paragraph from 'antd/lib/typography/Paragraph';
import Text from 'antd/lib/typography/Text';
import CodeBlock from '../CodeBlock';
import { BackendCodeSample, UserObjectStringMap } from './BackendCodeSample';

export default class BackendGoSample extends BackendCodeSample {
  name = 'Go';
  language = 'go';
  codeType = CodeType.BACKEND;
  tabIcon = '';
  commentChar = '//';

  buildCode({ environment, notification, user }: BuildCodeParams): ReactNode {
    const goInstall =
      'go get github.com/notificationapi-com/notificationapi-go-server-sdk';

    const code = `package main
import (
    notificationapi "github.com/notificationapi-com/notificationapi-go-server-sdk"
)

func main() {
  notificationapi.Init("${environment.clientId}", "${environment.clientSecret}")

  mergeTags := make(map[string]interface{}) // Change to map[string]interface{}
  mergeTags["comment"] = "Build something great :)"
  mergeTags["commentId"] = "commentId-1234-abcd-wxyz"

  phoneNumber := "${user.number}" //Replace with your phone number
  notificationapi.Send(
    notificationapi.SendRequest{
      NotificationId: "${notification.notificationId}",
      User: notificationapi.User{
        ${this.buildUserObjectString(user, '\n        ')}
      },
      MergeTags: mergeTags,
    },
  )
}`;

    return (
      <>
        <Paragraph style={{ paddingTop: 10 }}>
          To use the Go NotificationAPI SDK, you must install it with the{' '}
          <Text code>go get</Text> command:
        </Paragraph>
        <CodeBlock language="bash" code={goInstall} />
        <Paragraph>
          Once the NotificationAPI SDK is installed you can use the following
          code to send your first notification:
        </Paragraph>
        <CodeBlock language={this.language} code={code} />
      </>
    );
  }

  buildUserObject(user: User): UserObjectStringMap {
    return {
      id: `Id: "${user.id}"`,
      email: `Email: "${user.email}"`,
      number: {
        value: `Number: &phoneNumber,`
      }
    };
  }
}
